import { IEntity } from "../base/entity";

export interface IUserProfile extends IEntity {
    username: string;
}
